export default __webpack_public_path__ + "static/media/avtar16.60f1712e.jpg";